import { BaseService } from 'shared/services/BaseService';
import { ILaboratory } from '../types';

class LaboratoryService extends BaseService<ILaboratory> {
  constructor() {
    super('laboratories');
  }
}

export const laboratoryService = new LaboratoryService();
